import { Dialog, DialogContent, Grid, IconButton, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import CloseIcon from "@mui/icons-material/Close";
import icon_suscess from "../../../../../Image/icon_suscess.png";
interface IDataDialog {
    setOpenSuccessDialog: (open: boolean) => void;
    openSuccessDialog: boolean;
}


const DialogSuccessEditTable: React.FC<IDataDialog> = ({ setOpenSuccessDialog, openSuccessDialog }) => {

    const handleCloseSuccessDialog = () => {
        setOpenSuccessDialog(false)
    };

    useEffect(() => {
        if (openSuccessDialog) {
            const timer = setTimeout(() => {
                setOpenSuccessDialog(false);
            }, 2500);
            return () => clearTimeout(timer); // Cleanup on unmount or re-render
        }
    }, [openSuccessDialog]);

    return (
        <div>
            <Dialog
                sx={{ overflowY: 'hidden' }}
                open={openSuccessDialog}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
                        handleCloseSuccessDialog();
                    }
                }}
                fullWidth
                maxWidth="xs"
                PaperProps={{
                    sx: {
                        bgcolor: "#FFFFFF",
                        borderRadius: "20px",
                        boxShadow: 3,
                        p: 2,
                        width: "400px",
                    },
                }}
            >
                <IconButton
                    onClick={() => setOpenSuccessDialog(false)}
                    sx={{ position: "absolute", top: 8, right: 8 }}
                >
                    <CloseIcon />
                </IconButton>

                <DialogContent>
                    <Grid
                        container
                        spacing={2}
                        justifyContent="center"
                        alignItems="center"
                    >
                        <Grid item xs={12} display="flex" justifyContent="center" sx={{ mt: 3 }}>
                            <img
                                src={icon_suscess}
                                alt="รูปภาพ"
                                style={{
                                    width: 200,
                                    height: "auto",
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography
                                sx={{
                                    textAlign: "center",
                                    color: "#333333",
                                    fontSize: "19px",
                                    fontWeight: "700",
                                }}
                            >
                                เปลี่ยนแปลงพยานสำเร็จ
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography
                                sx={{
                                    mt: -1,
                                    textAlign: "center",
                                    color: "#636363",
                                    fontSize: "15px",
                                }}
                            >
                                เปลี่ยนแปลงพยาน (อนุมัติลำดับที่ 2) เรียบร้อยแล้ว
                            </Typography>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default DialogSuccessEditTable;
